import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import React, { useContext } from 'react'
import AdminLogo from '../../images/adminlogo-circle.png'
import Login from '../Login'
import axios from 'axios'
import Cookies from 'js-cookie'
import { AuthContext } from '../AuthContext'
import { Nav, Dropdown } from 'react-bootstrap'

const AdminNavbar = ({
  currentUser,
  setCurrentUser,
  loginShow,
  setLoginShow,
  redirectTo,
  setRedirectTo,
  sendDiscordNotification,
}) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { baseUrl } = useContext(AuthContext)
  const logOutUrl = '/api/crm/clinic/logout'

  // 登入檢查邏輯（與前台相同）
  const isLogin = (path) => {
    if (!currentUser) {
      setLoginShow(true)
      setRedirectTo(path)
    } else if (currentUser) {
      navigate('/admin')
    }
  }

  // 使用與前台相同的登出邏輯
  const handleLogout = (e) => {
    e.preventDefault()

    if (currentUser && currentUser.session) {
      axios
        .get(baseUrl + logOutUrl, {
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            Accept: '*/*',
            session: currentUser.session,
          },
        })
        .then((res) => {
          console.log('logout', res)
          Cookies.remove('session') // 🔄 使用 session cookie 而不是 admin_session
          setCurrentUser(null)
        })
        .catch((e) => {
          console.log('logout error', e)
          // 即使 API 失敗也要清除本地狀態
          Cookies.remove('session')
          setCurrentUser(null)
        })
    } else {
      // 如果沒有 session，直接清除本地狀態
      Cookies.remove('session')
      setCurrentUser(null)
    }
  }

  const handleLogoutClick = (e) => {
    e.preventDefault()
    setLoginShow(false)
    navigate('/admin')
    handleLogout(e)
  }

  return (
    <>
      <div
        className="d-flex flex-column haNav align-items-center"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100vh',
          zIndex: 1000,
        }}
      >
        <Link to="/admin">
          <div className="logoWrap mt-5">
            <img className="w-100" src={AdminLogo} alt="ha-logo" />
          </div>
        </Link>

        <Nav className="navItemsGroup flex-column">
          <h6 className="text-center mt-3 mb-4" style={{ color: '#67c7aa' }}>
            後台管理
          </h6>

          <NavLink to="/admin/push-task" className="nav-link">
            <i className="fa-solid fa-paper-plane me-2"></i>
            推送任務
          </NavLink>

          <NavLink to="/admin/push-task-list" className="nav-link">
            <i className="fa-solid fa-list me-2"></i>
            推送任務清單
          </NavLink>

          <NavLink to="/admin/contact-settings" className="nav-link">
            <i className="fa-solid fa-address-book me-2"></i>
            設定聯絡人
          </NavLink>
        </Nav>

        {/* Login/User Section */}
        {currentUser && (
          <Dropdown drop="end" className="user position-absolute">
            <Dropdown.Toggle size="lg" variant="" id="dropdown-basic">
              <i className="fa-solid fa-circle-user me-2"></i>
              <span
                style={{
                  maxWidth: '200px',
                  wordBreak: 'break-all',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {currentUser.doctor_name || currentUser.name} {'  '}
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ fontSize: '20px' }}>
              <Dropdown.Item as={Link} to="/">
                <i className="fa-solid fa-home me-2"></i>
                回到前台
              </Dropdown.Item>
              <Dropdown.Item onClick={handleLogoutClick}>
                <i className="fa-solid fa-right-from-bracket me-2"></i>
                登出
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}

        {/* Login 組件區域（與前台模式相同） */}
        <div className="user position-absolute">
          <Login
            currentUser={currentUser}
            setCurrentUser={setCurrentUser}
            loginShow={loginShow}
            setLoginShow={setLoginShow}
            redirectTo={redirectTo}
            setRedirectTo={setRedirectTo}
            sendDiscordNotification={sendDiscordNotification}
          />
        </div>
      </div>
    </>
  )
}

export default AdminNavbar
